import ModalWide from '@ui/components/Modal/variants/ModalWide'
import { CartItem } from '@order/hooks/useCart'
import useModalDataState from '@order/hooks/useModalDataState'
import { PaymentDetails } from '@order/hooks/usePayments'
import ModalContent from './ModalContent'

type PaymentDetailsModalProps = {
  data: CartItem
  paymentModal: ReturnType<typeof useModalDataState<PaymentDetails>>
}

export default function PaymentDetailsModal({
  data,
  paymentModal,
}: PaymentDetailsModalProps) {
  return (
    <ModalWide
      open={paymentModal.isOpen}
      close={paymentModal.close}
      hideBottomSpace
    >
      <ModalContent paymentModal={paymentModal} data={data} />
    </ModalWide>
  )
}
